import { Col, Progress, Row, Select } from "antd";
import React, { FC, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { deserialize } from "serializr";
import "./analyticsCard.scss";
import { ArrowLeftOutlined, DownOutlined } from "@ant-design/icons";
import ScoreIcon from "../../../../../assets/icons/reward.svg";
import AccuracyIcon from "../../../../../assets/icons/dart.svg";
import SpeedIcon from "../../../../../assets/icons/sketch.svg";
import DurationIcon from "../../../../../assets/icons/sand-clock.svg";
import { secondsFormatConverter } from "../../../../../shared/utils/secondsFormatConverter";

//container
import AnalyticsContainer from "../../../../../store/container/AnalyticsContainer";

//model
import { MetaModel } from "../../../../../models/CourseModels/SubjectModel/subject.model";
import { Students } from "../../../../../models/StudentsModel/students.model";
import { StudentClassResult } from "../../../../../models/Analytics/class.model";
//service
import { SubscriptionsService } from "../../../../../services/SubscriptionService/subscription.service";
import { AnalyticsService } from "../../../../../services/AnalyticsService/analytics.service";

interface AnalyticsCardProps {
  type: string;
  showPaper: boolean;
  setAnalyticsData: (result: StudentClassResult) => void;
  loading: boolean;
  setLoading: (load: boolean) => void
}
const AnalyticsCard: FC<AnalyticsCardProps> = ({
  type = "class_room",
  showPaper = false,
  setAnalyticsData,
  loading = false,
  setLoading
}) => {

  const { state }: { state: Students } = useLocation();

  const [classRooms, setClassRooms] = useState<MetaModel[]>([]);
  const [currentClassRooms, setCurrentClassRooms] = useState<any>();

  const [classAnalytics, setClassAnalytics] = useState<any>()

  const fetchSubscriptions = () => {
    if (state?.id) {
      SubscriptionsService.fetchSubscriptions(
        state?.id,
        (data) => {
          const meta = deserialize(MetaModel, data) as MetaModel[];
          setClassRooms(meta);
          if (meta.length) {
            let value = Number(meta[0].value)
            setCurrentClassRooms(value)
          }
        },
        () => { },
        () => { }
      );
    }
  };
  const fetchClass = () => {
    if (showPaper) {
      AnalyticsService.fetchPaperAnalytics(
        currentClassRooms,
        (result) => {
          setClassAnalytics(result);
        },
        () => { }
      );
    } else if (type == "exam") {
      AnalyticsService.fetchExamAnalytics(
        currentClassRooms,
        (result) => {
          setClassAnalytics(result);
        },
        () => { }
      );
    } else if (type == "class_room") {
      if (state?.id) {
        setLoading(true)
        AnalyticsService.fetchClassAnalytics(
          { CourseId: currentClassRooms, StudentId: state?.id },
          (result) => {
            setLoading(false)
            setAnalyticsData(result)
            setClassAnalytics(result);
          },
          () => { setLoading(false) }
        );
      }
    }
  };

  useEffect(() => {
    setAnalyticsData({})
    fetchSubscriptions();
  }, []);

  useEffect(() => {
    if (currentClassRooms !== undefined) {
      fetchClass();
    }
  }, [type, currentClassRooms]);




  return (
    <div className="analytics__card">
      <Row className="mlp-3" >
        <Col span={6}>
          <div className="analytics-rank__container">
            <Select
              value={currentClassRooms}
              className="course__dropdown"
              placeholder="Select course"
              options={classRooms}
              onChange={(value) => {
                setCurrentClassRooms(value);
              }}
            />
            {/* <div className="analytics__rank">Rank 04</div> */}
          </div>
        </Col>
      </Row>
      <Row className="mlp-3">
        <Col span={4}>
          <div className="analytics__metric">
            <img src={ScoreIcon} />
            <div>
              <p className="analytics-measure__value">
                {(classAnalytics?.score !== undefined ? (classAnalytics?.score)?.toFixed(1) : 0)} <span>%</span>
              </p>
              <p className="analytics__measure">Score</p>
            </div>
          </div>
        </Col>
        <Col span={4}>
          <div className="analytics__metric">
            <img src={AccuracyIcon} />
            <div>
              <p className="analytics-measure__value">
                {(classAnalytics?.accuracy !== undefined ? (classAnalytics?.accuracy)?.toFixed(1) : 0)} <span>%</span>
              </p>
              <p className="analytics__measure">Accuracy</p>
            </div>
          </div>
        </Col>
        <Col span={4}>
          <div className="analytics__metric">
            <img src={SpeedIcon} />
            <div>
              <p className="analytics-measure__value">
                {(classAnalytics?.averageTimePerQuestion !== undefined) ? (classAnalytics?.averageTimePerQuestion?.toFixed(1)) : 0}{" "}
                <span>sec/ques</span>
              </p>
              <p className="analytics__measure">Speed</p>
            </div>
          </div>
        </Col>
        <Col span={5}>
          <div className="analytics__metric">
            <img src={DurationIcon} />
            <div>
              <p className="analytics-measure__value">
                {secondsFormatConverter(
                  (classAnalytics?.exerciseAttemptDuration !== undefined) ? classAnalytics?.exerciseAttemptDuration * 60 : 0
                )}
              </p>
              <p className="analytics__measure">Duration spent</p>
            </div>
          </div>
        </Col>
        <Col span={7}>
          <div className="progress__metric">
            <div className="progress__container">
              <p className="progress__title">Content learnt</p>
              <div className="progress__wrapper">
                <p className="progress__score">
                  {classAnalytics?.completedContentCount || 0}
                  <span>/{classAnalytics?.totalContentCount || 0}</span>
                </p>
                <Progress percent={classAnalytics?.contentCompletionPercentage || 0}
                />
              </div>
            </div>
            <div className="progress__container">
              <p className="progress__title">Exercise attempted</p>
              <div className="progress__wrapper">
                <p className="progress__score">
                  {classAnalytics?.numberOfExerciseAttempts || 0}
                  <span>/{classAnalytics?.totalExerciseCount || 0}</span>
                </p>
                <Progress percent={classAnalytics?.exerciseCompletionPercentage || 0}
                />
              </div>
            </div>
          </div>
        </Col>
        {/* <Col span={3}>
          <img src={AccuracyIcon} />
          <p className="analytics-measure__value">
            40<span>/90</span>
          </p>
          <p className="analytics__measure">Exercise attempted</p>
        </Col>
        <Col span={3}>
          <img src={ScoreIcon} />
          <p className="analytics-measure__value">
            40<span>/90</span>
          </p>
          <p className="analytics__measure">Content learnt</p>
        </Col> */}
      </Row>
    </div>
  );
};
export default AnalyticsContainer(AnalyticsCard);
